<script lang="ts">
  import { i18nStore } from '../stores/i18nStore';
  import type { Language } from '../stores/i18nStore';
  import { locale, _ } from 'svelte-i18n';
  import { IconChevronDown } from '@tabler/icons-svelte';
  
  const languages: { code: Language; label: string; flag: string }[] = [
    { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'ja', label: '日本語', flag: '🇯🇵' },
    { code: 'es', label: 'Español', flag: '🇪🇸' },
  ];

  let isOpen = false;
  let currentLang: Language = 'en';

  i18nStore.subscribe((lang) => {
    currentLang = lang;
  });

  function selectLanguage(lang: Language) {
    i18nStore.setLanguage(lang);
    isOpen = false;
  }
</script>

<div class="relative">
  <button
    on:click={() => (isOpen = !isOpen)}
    class="glass-button flex items-center gap-2 px-4 py-2 rounded-lg transition-all cursor-pointer"
    aria-label="Select Language"
  >
    <span>{languages.find((l) => l.code === currentLang)?.flag}</span>
    <span class="text-sm font-medium">{languages.find((l) => l.code === currentLang)?.label}</span>
    <IconChevronDown class="w-4 h-4 transition-transform {isOpen ? 'rotate-180' : ''}" />
  </button>

  {#if isOpen}
    <div
      class="absolute top-full mt-2 right-0 z-50 glass-menu rounded-lg shadow-xl overflow-hidden min-w-[180px]"
    >
      {#each languages as lang}
        <button
          on:click={() => selectLanguage(lang.code)}
          class="w-full flex items-center gap-3 px-4 py-3 text-left text-slate-900 dark:text-white hover:bg-slate-100 dark:hover:bg-white/20 transition-colors cursor-pointer {currentLang === lang.code ? 'bg-slate-200 dark:bg-white/15' : ''}"
        >
          <span class="text-xl">{lang.flag}</span>
          <span class="text-sm font-medium">{lang.label}</span>
        </button>
      {/each}
    </div>
  {/if}
</div>

{#if isOpen}
  <div
    role="button"
    tabindex="-1"
    class="fixed inset-0 z-40"
    on:click={() => (isOpen = false)}
    on:keydown={(e) => e.key === 'Escape' && (isOpen = false)}
    aria-label="Close language menu"
  ></div>
{/if}
